module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/svg/toolbar_animation_exit_rotate_fill_light_24-99ad8b.svg";